import { render } from "./Alert_PopUp.vue?vue&type=template&id=0fed6806"
import script from "./Alert_PopUp.vue?vue&type=script&lang=js"
export * from "./Alert_PopUp.vue?vue&type=script&lang=js"

import "./Alert_PopUp.vue?vue&type=style&index=0&id=0fed6806&lang=scss"
script.render = render

export default script